
import './index.less'
import React from 'react'
import 'swiper/css/swiper.css'
import Smooth from './smooth.jsx'
import Center from './center.jsx'
import FadeInFadeOut from './fadeInFadeOut.jsx'
import Rotate3D from './3Drotate.jsx'
import Rol3D from './3Drol.jsx'
console.log(React)

export default function TopRotationCopy(props) {
  return (<div className={`TopRotation`} style={{
    opacity: 0.5,
    width: 375
  }}>
    {props.ifon.ifon.image_id_list.length ? null : <div className='TopRotation_div1'>
      <img src='https://read.e.qq.com/assets/images/yuebao/icon_upload_back.png' className='img' />
    </div>}

    {props.ifon.ifon.image_id_list.length ? <div className='TopRotation_box' style={{
      backgroundColor: props.ifon.ifon.backType === 1 ? 'transparent' : props.ifon.back,
      backgroundImage: props.ifon.ifon.backType === 1 && `url(${props.ifon.ifon.backImage.src})`,
      paddingTop: props.ifon.ifon.paddingTop,
      paddingBottom: props.ifon.ifon.paddingBottom,
      paddingLeft: props.ifon.ifon.paddingLeft,
      paddingRight: props.ifon.ifon.paddingRight
    }}>
      {exhibition(props)}
    </div> : null}
    <div className='Mantle1'></div>
  </div>)
}

function exhibition(props) {
  const type = props.ifon.ifon.type
  if (type === 0) {
    return <Smooth ifon={props.ifon.ifon} key={props.ifon.ifon.image_id_list.length} playbackSpeed={props.ifon.ifon.playbackSpeed}></Smooth>
  } else if (type === 1) {
    return <Center ifon={props.ifon.ifon} key={props.ifon.ifon.image_id_list.length} playbackSpeed={props.ifon.ifon.playbackSpeed}></Center>
  } else if (type === 2) {
    return <FadeInFadeOut ifon={props.ifon.ifon} key={props.ifon.ifon.image_id_list.length} playbackSpeed={props.ifon.ifon.playbackSpeed}></FadeInFadeOut>
  } else if (type === 3) {
    return <Rotate3D ifon={props.ifon.ifon} key={props.ifon.ifon.image_id_list.length} playbackSpeed={props.ifon.ifon.playbackSpeed}></Rotate3D>
  } else if (type === 4) {
    return <Rol3D ifon={props.ifon.ifon} key={props.ifon.ifon.image_id_list.length} playbackSpeed={props.ifon.ifon.playbackSpeed}></Rol3D>
  }
}
